(() => {
  const observeButton = () => {
    const button = document.querySelector('.kaching-bundles-sticky-atc__button');
    console.log('sticky-atc: observeButton run, button', Boolean(button));
    if (button && !button.dataset.scrollAdded) {
      console.log('sticky-atc: hooking button once');
      button.dataset.scrollAdded = 'true';
      button.addEventListener('click', (event) => {
        console.log('sticky-atc: button clicked, scrolling to MainContent');
        const mainContent = document.querySelector('#MainContent');
        if (mainContent) {
          event.preventDefault();
          mainContent.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        } else {
          console.log('sticky-atc: #MainContent not found');
        }
      });
    }
  };

  const initStickyAtcScrollFix = () => {
    window.console && console.log('Initializing sticky ATC scroll fix...');

    observeButton();

    const observer = new MutationObserver(observeButton);
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyAtcScrollFix);
  } else {
    initStickyAtcScrollFix();
  }
})();
